import api from "@/api/axios";

export default {
  // Admin Chat APIs
  getAllChats(params = {}) {
    return api.get("/chats", { params });
  },

  getChat(id) {
    return api.get(`/chats/${id}`);
  },

  getChatMessages(chatId, params = {}) {
    return api.get(`/chats/${chatId}/messages`, { params });
  },

  sendMessage(chatId, data) {
    return api.post(`/chats/${chatId}/messages`, data);
  },

  startWithUser(userId) {
    return api.post(`/chats/start-with-user/${userId}`);
  },
};
